import type { DropdownOption } from '../../components/UI/multi-select-dropdown/MultiSelectDropdown'

export const DateOptions = {
  Completed: 0,
  Expired: 1,
  Scheduled: 2,
  Started: 3
} as const
export type DateOptions = (typeof DateOptions)[keyof typeof DateOptions]

export type ExportFormatType = 'ICONS' | 'COMPLETE_DATE' | 'STARTED_DATE' | 'EXPIRED_DATE' | 'SCHEDULED_DATE'

export interface DateFieldOption extends DropdownOption {
  exportFormat: ExportFormatType
  hidden?: boolean
}

export const dateFieldOptions: DateFieldOption[] = [
  { value: String(DateOptions.Completed), text: 'Completed on', exportFormat: 'COMPLETE_DATE' },
  { value: String(DateOptions.Expired), text: 'Expires on', exportFormat: 'EXPIRED_DATE' },
  { value: String(DateOptions.Scheduled), text: 'Scheduled on', exportFormat: 'SCHEDULED_DATE' },
  { value: String(DateOptions.Started), text: 'Started on', exportFormat: 'STARTED_DATE' }
]
